import create from "zustand";

interface LoginStore {
  canAccessRoute: boolean;
  setCanAccessRoute: (value: boolean) => void;
}

export const useLoginStore = create<LoginStore>((set) => ({
  canAccessRoute: false,
  setCanAccessRoute: (value) => set({ canAccessRoute: value }),
}));
